module.exports = __webpack_public_path__ + "static/media/pd-2.eea5a3c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/pd-2.jpg
// module id = 126
// module chunks = 0